import { combineReducers } from 'redux';
import clan from './store/clan/reducer';
import player from './store/player/reducer';

export default combineReducers({
  clan,
  player,
});
